import React from 'lib/react';
import {
  EVButton,
  EVExplorerOverview, makeStyles,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { useEffect, useState } from 'react';
import { PITCH_EDITOR_ROUTE } from 'constants/RouteConstants';
import {
  CRYPTO_KEY, CRYPTO_IV, LEGACY_PORTAL_LINKS, HOST_URL,
} from 'constants/AppConstants';
import { encryptAndEncode } from 'utils/app.utils';
import { Link } from 'lib/router';
import * as featureFlags from 'constants/FeatureFlag.constants';
import { useSelector } from 'lib/redux';
import { featureFlagSelector, isRedirectExceptionOrgSelector } from 'utils/appSelectors.utils';

export const useStyles = makeStyles((theme) => ({
  editBtn: {
    width: '125px',
    backgroundColor: theme.evPalette.salt[100],
    borderColor: theme.evPalette.charcoal[300],
    padding: '4px 12px 4px 12px',
  },
  editBtnLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
  editPitchLink: {
    width: '125px',
    backgroundColor: theme.evPalette.salt[100],
    border: `1px solid ${theme.evPalette.charcoal[300]}`,
    padding: '4px 12px 4px 12px',
    color: theme.evPalette.ocean[600],
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textDecoration: 'none',
    borderRadius: '4px',
  },
}));

function EditPitchButton({ reportId, signedReportId }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [encryptedReportID, setEncryptedReportID] = useState(null);

  const myevRefreshLegacyRedirectFlag = useSelector(featureFlagSelector(featureFlags.REDIRECT_ACTION_BUTTONS_TO_LEGACY_PORTAL));
  const isRedirectExceptionOrg = useSelector(isRedirectExceptionOrgSelector);

  useEffect(() => {
    let isMounted = true;

    encryptAndEncode(reportId, CRYPTO_KEY, CRYPTO_IV)
      .then((encryptedID) => isMounted && setEncryptedReportID(encryptedID));

    return () => { isMounted = false; };
  }, []);

  const buttonProps = (() => {
    if (myevRefreshLegacyRedirectFlag) {
      return ({
        href: LEGACY_PORTAL_LINKS.pitchEditor + encryptedReportID,
        target: '_blank',
      });
    }

    const signatureQuery = signedReportId ? `&signature=${encodeURIComponent(signedReportId)}` : ''; // #genai

    if (isRedirectExceptionOrg) {
      return ({
        component: Link,
        to: `${PITCH_EDITOR_ROUTE}?reportId=${encryptedReportID}${signatureQuery}`,
      });
    }

    return ({
      href: `${HOST_URL}${PITCH_EDITOR_ROUTE}?reportId=${encryptedReportID}${signatureQuery}`,
      target: '_blank',
    });
  })();

  return (
    <EVButton
      id={`editBtn-${reportId}`}
      variant="outlined"
      color="primary"
      className={classes.editBtn}
      classes={{ label: classes.editBtnLabel }}
      onClick={(e) => e.stopPropagation()}
      {...buttonProps}
    >
      <EVExplorerOverview />
      {t('order_history__actions__edit_pitch')}
    </EVButton>
  );
}

EditPitchButton.propTypes = {
  reportId: PropTypes.number.isRequired,
  signedReportId: PropTypes.string,
};

EditPitchButton.defaultProps = {
  signedReportId: null,
};

export default EditPitchButton;
